import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const registry = {
  queryKey: queryKeys.registry,
  queryFn: Api.getRegistry,
};
